import * as z from 'zod'

export const ResetEnvDataLifecycleEventShape = z.object({
    type: z.literal('reset-environment-data'),
})

export const NukeDataLifecycleEventShape = z.object({
    type: z.literal('nuke-environment-data'),
})
